<template>
    <div class="d-flex align-items-center alert alert-dismissible fade show d-flex ps-3 pe-4" role="alert" :class="[alignment, alertType]" :style="border">
        <i class="fa-lg fa-regular my-3 my-sm-0 me-2" :class="faIcon" :style="'color:' + colourStyle"></i>
        <slot></slot>
        <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
      </div>
</template>

<script>
    export default {
        props: ['type', 'align'],
        computed: {
            alignment() {
                if(this.align) {
                    return 'align-items-sm-' + this.align;
                }
                
                return 'align-items-sm-center';
            },
            alertType() {
                return 'alert-' + this.type;
            },
            colourStyle() {
                var colour = 'inherit';
                
                if (this.type == 'danger') {
                    colour = '#d43030';
                }

                return colour;
            },
            border() {
                var colour = '#ccc';

                if(this.type == 'success') {
                    colour = '#68a51c';
                }
                else if(this.type == 'warning') {
                    colour = '#F7CC00';
                }
                else if (this.type == 'danger') {
                    colour = '#d43030';
                }
                else if (this.type == 'info') {
                    colour = '#13A1A7';
                }

                return 'border-color: ' + colour;
            },
            faIcon() {
                var icon = 'fa-circle-check';

                if(this.type == 'warning' || this.type == 'info') {
                    icon = 'fa-triangle-exclamation';
                }
                else if (this.type == 'danger') {
                    icon = 'fa-circle-exclamation';
                }

                return icon;
            }
        }
    }
</script>

<style lang="scss" scoped>
    div {
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
        padding: 10px;
    }
    .alert-dismissible {
        .btn-close {
            padding: 12px 10px;
        }
    }
</style>